<template>
  <b-row class="home no-gutters">
    <b-col class="tool-border" cols="12">
      <b-row class="no-gutters launch-bg">
        <b-col class="reduce-padding" lg="8" md="7" cols="12">
          <b-row class="no-gutters left-sec">
          <div class="heading-text">Thyroid Eye Disease
          Symptom Simulator</div>
          <div class="eye-image-sm"></div>
          <div class="sub-heading-text">Learn about the symptoms of TED and how they may progress over time.</div>
          <button class="get-started-btn" @click="getStarted" exact>GET STARTED</button>
          </b-row>
        </b-col>
        <b-col class="img-sec reduce-padding" lg="4" md="5" cols="12">
          <div id="preloaded-images">
                    <img src="../images/icon/menuhdr.webp" height="30px" class="pl" />
                    
                    <img  class="pl" src="../images/icon/home.webp"
                    srcset="data:../images/icon/homesm.webp 767w,
                    ../images/icon/home.webp 1200w"/>
                    
                    <img  class="pl" src="../images/icon/hdr.webp"
                    srcset="data:../images/icon/hdrsm.webp 767w,
                    ../images/icon/hdrmd.webp 991w, 
                    ../images/icon/hdr.webp 1200w"/>
            
                    
          </div>
          <div class="eye-image"></div>
        </b-col>
        
      </b-row>
    
          <b-row class="no-gutters launch-footer">
            <div class="common-text"><span class=" star-text">*</span><div class="footer-text"> This tool is not meant to provide medical advice and is for general educational purposes only. Some cases of TED will
 stabilize and then gradually improve. TED symptoms may present differently for each person and at different points in
 their disease progression.</div>
              
            </div>
          </b-row>
      
    </b-col>
    
  </b-row>
</template>
<script>
import scrollMixin from "../mixins/scrollMixin";

export default {
  name: "home",
  mixins: [scrollMixin],
  mounted: function () {
    this.scrollToTop();

  },
  components: {},

  data() {
    return {};
  },
  
  methods: {
    getStarted: function() {
      this.$router.push('menu');
      var obj={ 
        hitType: 'event',
          eventCategory: 'TED Symptoms Animation',
          eventAction: 'Get Started',
          eventLabel: 'Symptom Simulator'
        };
        try {
          console.log("sending Message:", JSON.stringify(obj));
          window.top.postMessage(JSON.stringify(obj), "*");
        } catch(e) {
          console.log("error sending Message");
        }
    }
  }
};
</script>


<style lang="scss" scoped>
</style>
